import * as ActionTypes from 'state/actions/types'

export const tagChangeField = (field, value) => {
  return {
    type: ActionTypes.TAG_CHANGE_FIELD,
    field,
    value
  }
}

export const tagChangeDateRange = (startDate, endDate) => {
  return {
    type: ActionTypes.TAG_CHANGE_CUSTOM_DATE_RANGE,
    startDate,
    endDate
  }
}

export const tagMoveCustomDateRange = operation => {
  return {
    type: ActionTypes.TAG_MOVE_CUSTOM_DATE_RANGE,
    operation
  }
}
